import responseData from './mocks/responseData';
import handleErrors from './handleErrors';

const responses = responseData();
const helpers = Object.freeze({
  responses,
  handleErrors,
});
export default helpers;
export { responses, handleErrors };
